function openSearch() {
    const modal = document.getElementById('SearchModal');
    const panel = document.getElementById('SearchCenterPanel');
    const overlay = document.getElementById('SearchOverlay');
    
    modal.classList.remove('hidden');
    document.body.style.overflow = 'hidden'; // منع السكرول في الخلفية

    setTimeout(() => {
      overlay.classList.add('opacity-100');
      panel.classList.remove('scale-95', 'opacity-0');
      panel.classList.add('scale-100', 'opacity-100');
      document.getElementById('SearchInput')?.focus();
    }, 10);
  }

  function closeSearch() {
    const modal = document.getElementById('SearchModal');
    const panel = document.getElementById('SearchCenterPanel');
    const overlay = document.getElementById('SearchOverlay');

    overlay.classList.remove('opacity-100');
    panel.classList.remove('scale-100', 'opacity-100');
    panel.classList.add('scale-95', 'opacity-0');

    setTimeout(() => {
      modal.classList.add('hidden');
      document.body.style.overflow = ''; 
    }, 300);
  }

  // إغلاق عند الضغط على زر Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSearch();
  });